<template>
  <modal :size="'large'">
    <div class="modal-header">
      <h4 class="title">นำเข้ารายการ</h4>
      <button
        @click.stop="onClose"
        type="button"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-5 mb-3">
            <ImageView
              :source="getCoverImage()"
              imageSize="cover640w360h"
              emptyMessageText="ไม่มีภาพปกรายการ" />
          </div>
          <div class="col-md-7">
            <FormGroup>
              <h5 class="name">เลือกรายการ</h5>
              <SelectOptionObject
                :value="selectedContent"
                :label="'title'"
                :options="content"
                :maxHeight="160"
                :placeholder="'ค้นหารายการ'"
                @onChanged="onSelectedContent"
                @onSearch="loadTpbsProgram"
              />
            </FormGroup>
            <FormGroup  class="mb-0">
              <h5 class="name">เนื้อหารายการ</h5>
              <div class="form-wrapper">
                <div class="form-check">
                  <input
                    v-model="isImportVideo"
                    type="checkbox"
                    class="form-check-input">
                  <label class="form-check-label">
                    นำเข้าวิดีโอทั้งหมดของรายการ
                  </label>
                </div>
                <small class="helper-text">
                  * หากต้องการนำเข้าเฉพาะวิดีโอที่ต้องการ
                  <router-link :to="'/videos/import'">
                    คลิกที่นี่
                  </router-link>
                </small>
              </div>
              <div class="form-wrapper">
                <div class="form-check">
                  <input
                    v-model="isImportEpisode"
                    type="checkbox"
                    class="form-check-input">
                  <label class="form-check-label">
                    นำเข้าตอนทั้งหมดของรายการ
                  </label>
                </div>
                <small class="helper-text">
                  * หากต้องการนำเข้าเฉพาะตอนที่ต้องการ
                  <router-link :to="'/episodes/import'">
                    คลิกที่นี่
                  </router-link>
                </small>
              </div>
            </FormGroup>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="error-text" v-if="errorCode">บันทึกไม่สำเร็จกรุณาติดต่อผู้ดูแลระบบ (code: {{errorCode}})</div>
        <button
          class="btn btn-primary"
          type="submit"
          :disabled="errorCode">
          <i class="fa fa-spinner fa-spin mr-1" v-if="isSaving"/>บันทึก
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import _ from 'lodash';
import { loadTpbsProgram, importTpbsProgram } from '@/program/api';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import ImageView from '@/image/ImageView.vue';

export default {
  props: {
    contentType: {
      type: String,
      default: 'content',
    },
  },
  components: {
    Modal,
    FormGroup,
    ImageView,
    SelectOptionObject,
  },
  data() {
    return {
      content: [],
      selectedContent: null,
      isImportVideo: false,
      isImportEpisode: false,
      isSaving: false,
      errorCode: null,
    };
  },
  created() {
    this.loadTpbsProgram();
  },
  methods: {
    async loadTpbsProgram(filter) {
      const response = await loadTpbsProgram(filter);
      this.content = response.data.data;
    },
    onSelectedContent(content) {
      this.selectedContent = content;
    },
    async onSubmit() {
      this.isSaving = true;
      try {
        const body = {
          programKey: this.selectedContent.key,
          isImportEpisode: this.isImportEpisode,
          isImportVideo: this.isImportVideo,
        };
        await importTpbsProgram(body);
        this.onClose();
      } catch (error) {
        this.errorCode = error.response.status;
        this.isSaving = false;
      }
    },
    // translateContentType() {
    //   if (this.contentType === 'programs') return 'รายการ';
    //   return 'คอนเทนท์';
    // },
    onClose() {
      this.$router.push('/programs');
    },
    getCoverImage() {
      return _.get(this.selectedContent, 'display_image.sizes.default.url', '');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';

.modal-body {
  min-height: 250px;
}

.error-text {
  font-size: 80%;
  color: #dc3545;
}

.helper-text {
  color: $gray-500
}

.name {
  font-weight: bold !important;
}

.form-wrapper {
  margin-bottom: $spacer / 2;
}
</style>
